import React from "react";
import BootstrapIcon from "../../Common/BootstrapIcon";
const MissionItem = ({ mission, onChange, value }) => {
    const onCheckboxClick = (event) => {
        const missionId = +event.target.value;
        onChange(!event.target.checked ? value.filter((m) => m !== missionId) : [...value, missionId]);
    };
    if (mission.locked) {
        const tootltipMessage = mission.canPostReason === "disallowed_noparticipate"
            ? "This mission is expired"
            : mission.canPostReason === "disallowed_nopremium"
                ? "This mission requires premium"
                : mission.canPostReason === "disallowed_type"
                    ? "The mission admin has disabled this exercise type"
                    : "";
        return (React.createElement("div", { className: "d-flex justify-content-between align-items-center form-check border-bottom py-1", 
            // @ts-ignore
            rel: "tooltip", title: tootltipMessage, "data-CanPostReason": mission.canPostReason },
            React.createElement("div", null,
                React.createElement("input", { className: "form-check-input", type: "checkbox", disabled: true }),
                React.createElement("label", { className: "mb-0 small grey" }, mission.name)),
            mission.canPostReason === "disallowed_nopremium" ? (React.createElement(BootstrapIcon, { icon: "star-fill", className: "danger", height: 14 })) : mission.canPostReason === "disallowed_noparticipate" ? (React.createElement(BootstrapIcon, { icon: "watch", className: "danger", height: 14 })) : (React.createElement(BootstrapIcon, { icon: "lock-fill", className: "danger", height: 14 }))));
    }
    return (React.createElement("div", { className: "form-check border-bottom py-1" },
        React.createElement("input", { className: "form-check-input", type: "checkbox", name: mission.id.toString(), id: mission.id.toString(), value: mission.id, checked: value.includes(mission.id), onChange: onCheckboxClick }),
        React.createElement("label", { className: "mb-0 w-100 small dark-grey", htmlFor: mission.id.toString() }, mission.name)));
};
export default React.memo(MissionItem);
